import ENV from "../env";

const getOrgTables = async (orgId) => {
  if (!orgId) return [];

  try {
    const response = await fetch(
      `${ENV.firebaseApiUrl}/organization/${orgId}/tables`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch tables");
    }

    return data.tables || [];
  } catch (err) {
    console.error("Error fetching tables:", err);
    return [];
  }
};

export default getOrgTables;
